import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'ConsumableQuantityEstimation',
  //   description: 'description of ConsumableQuantityEstimation',
  //   url: '/consumable-quantity-estimation',
  // },
];

export default help;
